export default {
  GET_CURRENT_USER: 'get_current_user',
  GET_MEMBERS: 'get_members'
}



// WEBPACK FOOTER //
// ./src/action/types.js